import { format } from "date-fns";
import _ from "lodash";
import React from "react";
import DatePicker from "react-datepicker";
import { FaCalendar } from "react-icons/fa";
import "./CustomDatePicker.scss";
import CustomInput from "./CustomInput";

import "react-datepicker/dist/react-datepicker.css";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";

const CustomDatePickerInput = React.forwardRef(({ onChange, value, onClick, placeholder, floatingLabel, disabled }, ref) => {
  return (
    <div
      className={`customDatepickerInputWrapper ${disabled ? "disabled" : ""}`}
      onClick={!disabled ? onClick : undefined} // Prevent clicks when disabled
      ref={ref}
    >
      <CustomInput
        icon={<FaCalendar />}
        className="customDatePickerInput"
        value={value}
        onChange={onChange}
        disabled={disabled}
        floatingLabel={floatingLabel}
        placeholder={placeholder}
      />
    </div>
  );
});

CustomDatePickerInput.displayName = "CustomDatePickerInput";

const CustomHeader = ({ date, years, months, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
  <div className="customDatePickerHeader">
    <button
      className="arrowButton"
      onClick={decreaseMonth}
      disabled={prevMonthButtonDisabled}
    >
      <HiChevronLeft />
    </button>
    <select
      value={date.getFullYear()}
      onChange={({ target: { value } }) => changeYear(value)}
    >
      {years.map((option) => (
        <option
          key={option}
          value={option}
        >
          {option}
        </option>
      ))}
    </select>
    <select
      value={date.getMonth()}
      onChange={({ target: { value } }) => changeMonth(Number(value))}
    >
      {months.map((month, index) => (
        <option
          key={index}
          value={index}
        >
          {month}
        </option>
      ))}
    </select>
    <button
      className="arrowButton"
      onClick={increaseMonth}
      disabled={nextMonthButtonDisabled}
    >
      <HiChevronRight />
    </button>
  </div>
);

const CustomDatePicker = ({ selectedDate, handleDateChange, isDisabled, placeholder, locale, floatingLabel, minDate }) => {
  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  const years = _.range(2021, new Date().getFullYear() + 2, 1);

  const months = Array.from({ length: 12 }, (_, i) => capitalize(format(new Date(2000, i, 1), "LLLL", { locale: locale ? locale.value : null })));

  const handleDatePickerChange = (date) => {
    if (!date) {
      handleDateChange(null);
      return;
    }

    const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    utcDate.setUTCHours(12, 0, 0, 0);

    handleDateChange(utcDate.toISOString());
  };

  return (
    <DatePicker
      name="date"
      selected={selectedDate ? new Date(selectedDate) : null}
      onChange={handleDatePickerChange}
      dateFormat="yyyy-MM-dd"
      placeholderText={placeholder ? placeholder : " "}
      locale={null}
      popperPlacement="top-start"
      portalId="datepicker-portal"
      customInput={React.cloneElement(<CustomDatePickerInput />, { floatingLabel })}
      strictParsing={true}
      renderCustomHeader={(props) => (
        <CustomHeader
          {...props}
          years={years}
          months={months}
        />
      )}
      disabled={isDisabled}
      minDate={minDate}
    />
  );
};

export default CustomDatePicker;
